import React, { PureComponent } from 'react';
import { send_contact_me_message } from '../../services/services';
import { T } from '../../../../common/locale/translate';
import { trackAnalyticsEvent } from '../../services/analytics';

export default class NoOffersContactForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pristine: true,
      messageSend: false,
      email: {
        focused: false,
        value: ''
      },
      phone: {
        focused: false,
        value: ''
      }
    };
  }

  render = () => {
    const {
      header,
      className,
      sendButtonText,
      isOfferVariantsForm
    } = this.props;
    const { email, phone, pristine, messageSend } = this.state;
    const validContactData =
      this.validatePhone(phone.value) || this.validateEmail(email.value);

    return (
      <div className={`no-offers-contact-form ${className}`}>
        {!messageSend && (
          <div>
            <h3
              className="no-offers-contact-form-header"
              dangerouslySetInnerHTML={{
                __html: header
              }}
            />
            <p className="no-offers-contact-form-description">
              {T('no_offers_contact_form_description')}
            </p>
            <div className="no-offers-contact-form-inputs-wrapper">
              <input
                className={email.focused ? 'active' : ''}
                type="text"
                name="email"
                placeholder={T('example_email')}
                onFocus={this.handleFocus}
                onChange={this.handleInputChange}
              />
              (
              <input
                className={phone.focused ? 'active' : ''}
                type="phone"
                name="phone"
                placeholder="+48 XXX-XXX-XXX"
                onFocus={this.handleFocus}
                onChange={this.handleInputChange}
              />
              )
              {isOfferVariantsForm && (
                <div className="send_message_wrapper">
                  <button onClick={this.handleSave}>{sendButtonText}</button>
                </div>
              )}
              {!pristine &&
                !validContactData && (
                  <div>
                    <span className="error-message">
                      {T('no_offers_contact_form_error')}
                    </span>
                  </div>
                )}
            </div>
            {(email.focused || phone.focused || !pristine) && (
              <span className="rodo-information">
                {T('no_offers_contact_form_rodo_information')}
              </span>
            )}
            {!isOfferVariantsForm && (
              <div className="send_message_wrapper">
                <button onClick={this.handleSave}>{sendButtonText}</button>
              </div>
            )}
          </div>
        )}
        {messageSend && (
          <div className="message-send">
            <h3>{T('no_offers_contact_form_message_send_header')}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: T('no_offers_contact_form_message_send_description')
              }}
            />
          </div>
        )}
      </div>
    );
  };

  handleFocus = event => {
    this.setState({
      [event.target.name]: {
        ...this.state[event.target.name],
        focused: true
      }
    });
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: {
        ...this.state[event.target.name],
        value: event.target.value
      }
    });
  };

  validatePhone = phone => {
    return /^[+]{0,1}[0-9 -]{8,15}$/.test(phone);
  };

  validateEmail = email => {
    return /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/.test(
      email
    );
  };

  handleSave = () => {
    const { email, phone } = this.state;
    const validContactData = this.validateEmail(email.value) == true;
    this.setState({ pristine: false });
    if (validContactData) {
      const offerLink = window.location.toString();
      trackAnalyticsEvent(
        'kontakt z biurem',
        'formularz',
        'prośba o kontakt  - brak ofert na liście'
      );
      send_contact_me_message(email.value, phone.value, offerLink).then(() => {
        this.setState({ messageSend: true });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/no-offers-contact-form.js